import createManagementPaginationMethods from "@shared/createManagementPaginationMethods.cjs";

export default createManagementPaginationMethods({
  loadMethod: "loadNotices",
});
